import React from 'react';

export function FilterPopover({
  projects,
  pendingFilters,
  onStatusToggle,
  onProjectChange,
  onDateChange,
  onApply,
  onClear,
  onClose,
}) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-3 shadow-lg text-sm">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Status</p>
        <div className="mt-2 space-y-1">
          <label className="flex items-center gap-2 text-slate-700">
            <input
              type="radio"
              name="status-filter-popover"
              checked={!pendingFilters.status}
              onChange={() => onStatusToggle('')}
            />
            All
          </label>
          {['draft', 'finalized', 'archived', 'void'].map((value) => (
            <label key={value} className="flex items-center gap-2 text-slate-700">
              <input
                type="radio"
                name="status-filter-popover"
                checked={pendingFilters.status === value}
                onChange={() => onStatusToggle(value)}
              />
              {value.charAt(0).toUpperCase() + value.slice(1)}
            </label>
          ))}
        </div>
      </div>

      <div className="mt-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Project</p>
        <select
          className="mt-1 w-full rounded border border-slate-300 p-2 text-sm"
          value={pendingFilters.project}
          onChange={(e) => onProjectChange(e.target.value)}
        >
          <option value="">All projects</option>
          {projects.map((project) => (
            <option key={project.id} value={project.id}>
              {project.code || project.name}
            </option>
          ))}
        </select>
      </div>

      <div className="mt-3 grid gap-2">
        <label className="text-slate-700">
          <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">From</span>
          <input
            type="date"
            className="mt-1 w-full rounded border border-slate-300 p-2 text-sm"
            value={pendingFilters.dateFrom}
            onChange={(e) => onDateChange('dateFrom', e.target.value)}
          />
        </label>
        <label className="text-slate-700">
          <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">To</span>
          <input
            type="date"
            className="mt-1 w-full rounded border border-slate-300 p-2 text-sm"
            value={pendingFilters.dateTo}
            onChange={(e) => onDateChange('dateTo', e.target.value)}
          />
        </label>
      </div>
      <p className="mt-1 text-xs text-slate-400">
        TODO: wire date filters to the backend once supported.
      </p>

      <div className="mt-4 flex items-center justify-between gap-2">
        <button
          className="rounded border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
          type="button"
          onClick={onClear}
        >
          Clear
        </button>
        <div className="flex gap-2">
          <button
            className="rounded border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
            type="button"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="rounded bg-slate-900 px-3 py-2 text-sm font-semibold text-white hover:bg-slate-800"
            type="button"
            onClick={onApply}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
